import React from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { SmallArrowIcon } from "@/assets/icons";
import { useUserDataContext } from "@/store/UserProvider";
import { usePaymentOptionStore } from "@/store/paymentOption";
import { useTranslation } from "react-i18next";
import { AddNewCardPage } from "./AddNewCardPage";
import { ConfirmPaymentOptionPage } from "./ConfirmPaymentOptionPage";
import { DeletePaymentMethodModal } from "./DeletePaymentMethodModal";
import { PaymentOptionsList } from "./PaymentOptionsList";
import {
  ChoosePaymentOptionsProvider,
  useChoosePaymentOptionsContext,
} from "./ChoosePaymentOptionsContext";
import {
  getCardLastNumbers,
  getSavedPaymentMethods,
  HIDDEN_CARD_MASK,
} from "./paymentOptionHelpers";
import cls from "./styles.module.scss";

function ChoosePaymentOptionsContent() {
  const { t } = useTranslation();
  const { user, paymentOption } = useUserDataContext();
  const { goToStep } = usePaymentOptionStore();
  const {
    step,
    isManageMode,
    hasSavedCards,
    toggleManageMode,
    pendingDeletePaymentMethodId,
    cancelDeleteCard,
    confirmDeleteCard,
  } = useChoosePaymentOptionsContext();

  const savedPaymentMethods = getSavedPaymentMethods(user);
  const currentCard = savedPaymentMethods.find(
    (elem) => elem.payment_method_id === paymentOption
  )?.card_metadata?.last4;

  if (step === "addNewCard") {
    return <AddNewCardPage />;
  }

  if (step === "confirm") {
    return <ConfirmPaymentOptionPage />;
  }

  return (
    <FlexColumn gap={24} className={cls.paymentOptionBlock}>
      <button
        type="button"
        className={cls.btnArrow}
        onClick={() => goToStep("firstPage")}
      >
        <SmallArrowIcon />
      </button>
      {hasSavedCards && (
        <button
          type="button"
          className={cls.changeModeBtn}
          onClick={toggleManageMode}
        >
          {isManageMode ? t("common.back") : t("paymentOptions.edit")}
        </button>
      )}
      <Typography className={cls.heading}>
        {t("paymentOptions.changePaymentOption")}
      </Typography>
      <Typography className={cls.desc}>
        {t("paymentOptions.paymentOptionNow")}{" "}
        {`${t(
          "paymentOptions.paymentOptionCard"
        )} ${HIDDEN_CARD_MASK}${getCardLastNumbers(currentCard)}`}
        . {"\n"} {t("paymentOptions.canChoosePaymentOption")}
      </Typography>
      <PaymentOptionsList />
      <DeletePaymentMethodModal
        isOpen={Boolean(pendingDeletePaymentMethodId)}
        onCancel={cancelDeleteCard}
        onConfirm={confirmDeleteCard}
      />
    </FlexColumn>
  );
}

export function ChoosePaymentOptions() {
  return (
    <ChoosePaymentOptionsProvider>
      <ChoosePaymentOptionsContent />
    </ChoosePaymentOptionsProvider>
  );
}
